var render, staticRenderFns
import script from "./LongTouch.vue?vue&type=script&lang=js&"
export * from "./LongTouch.vue?vue&type=script&lang=js&"
import style0 from "./LongTouch.vue?vue&type=style&index=0&id=3e2a4a86&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2a4a86",
  null
  
)

export default component.exports